import { Box } from '@mui/material';
import { PartnerPlaceholderImage } from 'assets/img';
import { StyledCell } from 'FeatureModules/Partner/Components/PartnersTable/PartnersTableBody/PartnersTableBody.styles';
import { StyledTableBody, StyledTableRow } from 'Components/TableBase/Table';
import { ThemeTypography } from 'DesignSystem';
import Image from 'DesignSystem/DataDisplay/Image/Image';
import React, { FC, MouseEvent } from 'react';
import Moment from 'react-moment';
import {
  IQuestionnaire,
  IQuestionnaireCompanyResponse,
} from 'FeatureModules/Questionnaire/types/questionnaire.types';
import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';
import QuestionnaireTitle from '../QuestionnaireTable/QuestionnaireTitle';
import { EQuestionnaireResponseHeaderColumnEnum } from './questionnaireResponseHeaderColumns';

interface IProps {
  questionnaire: IQuestionnaire;
  responses: IQuestionnaireCompanyResponse[];
  headerColumns: IHeaderColumn<EQuestionnaireResponseHeaderColumnEnum>[];
  onResponseClick: (response: IQuestionnaireCompanyResponse) => void;
}

const QuestionnaireResponseTableBody: FC<IProps> = ({
  questionnaire,
  responses,
  onResponseClick,
  headerColumns,
}) => {
  return (
    <StyledTableBody>
      {responses.map((response, index) => {
        return (
          <StyledTableRow
            hover
            data-testid="questionnaire-response-table-row"
            key={`${response.id}-${index}`}
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
              onResponseClick(response);
            }}
          >
            {headerColumns.map(({ id: column, align }) => {
              switch (column) {
                case EQuestionnaireResponseHeaderColumnEnum.TITLE:
                  return (
                    <StyledCell key={column} scope="row" align={align}>
                      <QuestionnaireTitle
                        title={questionnaire.title}
                        year={questionnaire.year}
                        externalId={questionnaire.externalId}
                        riskLevel={response.riskLevel}
                        partnerName={response.partnerRequest?.requestedToCompany?.name}
                      />
                    </StyledCell>
                  );

                case EQuestionnaireResponseHeaderColumnEnum.ASSESSED_PARTNER:
                  return (
                    <StyledCell key={column} scope="row" align={align}>
                      {response.partnerRequest?.requestedToCompany && (
                        <Box display="flex" alignItems="center">
                          <Image
                            width={44}
                            height={44}
                            image={response.partnerRequest?.requestedToCompany.logo}
                            backupImageUrl={PartnerPlaceholderImage}
                          />
                          <Box ml={1}>
                            <ThemeTypography variant="ITEM_SUBTITLE">
                              {response.partnerRequest?.requestedToCompany.name}
                            </ThemeTypography>
                          </Box>
                        </Box>
                      )}
                    </StyledCell>
                  );

                case EQuestionnaireResponseHeaderColumnEnum.DATE_COMPLETED:
                  return (
                    <StyledCell key={column} scope="row" align={align}>
                      <ThemeTypography variant="BODY_MEDIUM">
                        <Moment format="MMMM DD, YYYY">
                          {response.partnerRequest?.latestLog?.timestamp}
                        </Moment>
                      </ThemeTypography>
                    </StyledCell>
                  );

                default:
                  return null;
              }
            })}
          </StyledTableRow>
        );
      })}
    </StyledTableBody>
  );
};

export default QuestionnaireResponseTableBody;
